import { MessageCircle, Star } from "lucide-react";
import { Reveal } from "./Reveal";
import { WHATSAPP_URL, WHATSAPP_NUMBER } from "@/lib/site";

export const FinalCta = () => (
  <section data-testid="final-cta" className="px-5 pb-24 sm:pb-32">
    <Reveal className="mx-auto max-w-6xl">
      <div className="relative overflow-hidden rounded-[2.5rem] bg-[#4285F4] px-8 py-16 text-center sm:px-16 sm:py-24">
        <Star className="pointer-events-none absolute -left-8 -top-8 h-40 w-40 rotate-12 fill-white/10 text-white/10" />
        <Star className="pointer-events-none absolute -bottom-10 -right-10 h-52 w-52 -rotate-12 fill-white/10 text-white/10" />
        <h2 className="font-display relative mx-auto max-w-2xl text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
          La prossima recensione a 5 stelle è a un tap di distanza.
        </h2>
        <p className="relative mx-auto mt-5 max-w-xl text-base leading-relaxed text-blue-100 sm:text-lg">
          Scrivici ora su WhatsApp: ti rispondiamo subito con un preventivo su misura per la tua attività.
        </p>
        <div className="relative mt-9 flex flex-col items-center gap-4">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="final-whatsapp-cta"
            className="group flex items-center gap-3 rounded-full bg-white px-8 py-4 text-base font-bold text-[#1EBE5D] shadow-2xl shadow-blue-900/30 transition-transform duration-300 hover:scale-105 sm:text-lg"
          >
            <MessageCircle className="h-6 w-6 fill-[#25D366] text-[#25D366] transition-transform duration-300 group-hover:-rotate-12" />
            Scrivici su WhatsApp
          </a>
          <span className="text-sm font-medium text-blue-100" data-testid="final-phone-number">{WHATSAPP_NUMBER}</span>
        </div>
      </div>
    </Reveal>
  </section>
);
